import $ from 'jquery'
import {Core} from "../../../assets/src/scripts/core.js";

export class PlotPricing {
  constructor($container) {
    this.classes = {
      active: 'active',
    }
    this.$container = $container
    this.$choices = this.$container.find('.plot-pricing-dual-price-content')

    this.$choices.on('click', 'button', this.handleClickButton.bind(this))
  }

  handleClickButton(e) {
    e.preventDefault()
    let $button = $(e.currentTarget)
    let target = $button.data('id')

    const activeTarget = this.$container.find(`.${this.classes.active}:not(svg)`);
    activeTarget.removeClass(this.classes.active)

    $button.addClass(this.classes.active)
    this.$container.find(`.${target}`).addClass(this.classes.active)
  }
}
